import { ArrowUpRight } from "lucide-react";

const COL_LINKS = [
    {
        title: "Plateforme",
        items: [
            { label: "Espace client", href: "https://carvaelis.com/" },
            { label: "Espace convoyeur", href: "https://carvaelis.com/" },
            { label: "Tarifs", href: "https://carvaelis.com/" },
        ],
    },
    {
        title: "Navigation",
        items: [
            { label: "Concept", href: "#how-it-works" },
            { label: "Sécurité", href: "#trust-safety" },
            { label: "FAQ", href: "#faq-section" },
            { label: "Contact", href: "#contact-section" },
        ],
    },
    {
        title: "Légal",
        items: [
            { label: "Mentions légales", href: "https://carvaelis.com/" },
            { label: "CGU", href: "https://carvaelis.com/" },
            { label: "Confidentialité", href: "https://carvaelis.com/" },
        ],
    },
];

export default function Footer() {
    return (
        <footer
            data-testid="footer-section"
            className="bg-ink text-white relative overflow-hidden"
        >
            <div className="container-x py-20">
                <div className="grid lg:grid-cols-12 gap-10 pb-16 border-b border-white/10">
                    <div className="lg:col-span-5">
                        <a
                            href="https://carvaelis.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-cta-main"
                            className="inline-flex items-center gap-2 text-signal text-xs uppercase tracking-[0.2em] font-bold mb-6 hover:text-white transition-colors"
                        >
                            La plateforme
                            <ArrowUpRight className="w-3.5 h-3.5" />
                        </a>
                        <h3 className="font-display font-black tracking-tighter text-white text-3xl sm:text-4xl leading-tight max-w-md">
                            Convoyer en toute sécurité,
                            <br />
                            partout en France.
                        </h3>

                        <a
                            href="https://carvaelis.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-cta-primary"
                            className="mt-8 inline-flex items-center gap-3 bg-signal hover:bg-white hover:text-ink text-white px-6 py-4 font-bold uppercase tracking-wider text-sm transition-colors"
                        >
                            Accéder à la plateforme
                            <ArrowUpRight className="w-4 h-4" />
                        </a>
                    </div>

                    <div className="lg:col-span-7 grid grid-cols-3 gap-8">
                        {COL_LINKS.map((col) => (
                            <div key={col.title}>
                                <div className="text-xs uppercase tracking-[0.2em] text-white/40 font-bold mb-5">
                                    {col.title}
                                </div>
                                <ul className="space-y-3">
                                    {col.items.map((l) => (
                                        <li key={l.label}>
                                            <a
                                                href={l.href}
                                                target={
                                                    l.href.startsWith("http")
                                                        ? "_blank"
                                                        : undefined
                                                }
                                                rel={
                                                    l.href.startsWith("http")
                                                        ? "noopener noreferrer"
                                                        : undefined
                                                }
                                                data-testid={`footer-link-${l.label
                                                    .toLowerCase()
                                                    .replace(/\s/g, "-")}`}
                                                className="text-sm text-white/70 hover:text-signal transition-colors"
                                            >
                                                {l.label}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Big logo */}
                <div className="pt-12 pb-4 select-none">
                    <div
                        data-testid="footer-bigtype"
                        className="font-display font-black tracking-tighter text-[18vw] lg:text-[14rem] leading-none text-white/5"
                    >
                        Carvaelis
                    </div>
                </div>

                <div className="flex flex-col sm:flex-row gap-4 sm:items-center sm:justify-between text-xs text-white/40 uppercase tracking-wider">
                    <div>
                        © {new Date().getFullYear()} Carvaelis — Tous
                        droits réservés.
                    </div>
                    <div>
                        Convoyage de véhicules · France métropolitaine
                    </div>
                </div>
            </div>
        </footer>
    );
}
